<template>
  <div v-if="isPreview" class="border-b border-amber-200 bg-amber-50 dark:border-amber-900/70 dark:bg-amber-950/40">
    <div class="mx-auto flex max-w-5xl flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <div class="flex items-start gap-3">
        <span class="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-amber-100 text-amber-700 dark:bg-amber-400/15 dark:text-amber-300">
          <UIcon name="i-heroicons-eye" class="h-4 w-4" />
        </span>
        <div>
          <p class="text-sm font-semibold text-amber-950 dark:text-amber-100">Draft preview</p>
          <p class="text-xs leading-5 text-amber-800 dark:text-amber-300">
            This is the saved draft in the real blog layout. It is still hidden from readers.
          </p>
        </div>
      </div>
      <UButton
        :to="editorPath"
        color="neutral"
        variant="soft"
        size="sm"
        icon="i-heroicons-pencil-square"
      >
        Back to editor
      </UButton>
    </div>
  </div>

  <BlogArticle :article="article" :full="true"/>
</template>

<script setup lang="ts">
import { setSeoMeta } from '~/utils/meta'
import type { AdminBlogArticle, BlogArticle } from '~/utils/interfaces'

const route = useRoute()
const slug = route.params.slug as string
const previewValue = Array.isArray(route.query.preview) ? route.query.preview[0] : route.query.preview
const parsedPreviewID = typeof previewValue === 'string' ? Number.parseInt(previewValue, 10) : Number.NaN
const previewID = Number.isInteger(parsedPreviewID) && parsedPreviewID > 0 ? parsedPreviewID : null
const isPreview = previewID !== null

let article: BlogArticle
if (previewID) {
  const { data, error } = await useSetupApi2<AdminBlogArticle>(`/admin/articles/${previewID}`, {
    authenticated: true,
  })
  if (error.value || !data.value) {
    throw createError({ statusCode: 404, statusMessage: 'Article not found' })
  }
  article = data.value
} else {
  const { data, error } = await useSetupApi2<{ data: BlogArticle }>(`/blog/articles/${slug}`)
  if (error.value || !data.value?.data) {
    throw createError({ statusCode: 404, statusMessage: 'Article not found' })
  }
  article = data.value.data
}

const editorPath = previewID
  ? `/admin-go-k73mdnc0983-mndk-ssaalje-ss2/blog/${previewID}`
  : '/admin-go-k73mdnc0983-mndk-ssaalje-ss2/blog'

const seoTitle = `${article.title} - Jesse Blog`
const seoDescription = article.description
setSeoMeta(seoTitle, seoDescription, null, 'article')

if (isPreview) {
  useSeoMeta({ robots: 'noindex, nofollow' })
}
</script>
